import Pusher, { ChannelAuthorizationHandler } from 'pusher-js';
import { httpInstance } from '../services/http-service';
import Echo from 'laravel-echo';

const options = {
  broadcaster: 'pusher',
  key: import.meta.env.VITE_PUSHER_APP_KEY,
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
  forceTLS: true,
};

export default function useLaravelEcho() {
  if (import.meta.env.MODE === 'development') {
    Pusher.logToConsole = true;
  }

  const customHandler: ChannelAuthorizationHandler = (params, callback) => {
    httpInstance
      .post('/broadcasting/auth', {
        socket_id: params.socketId,
        channel_name: params.channelName,
      })
      .then((response) => {
        callback(null, {
          auth: response.data.auth,
        });
      })
      .catch((error) => {
        callback(error, {
          auth: error.data.auth,
        });
      });
  };

  const echo = new Echo({
    ...options,
    client: new Pusher(options.key, {
      ...options,
      channelAuthorization: {
        transport: 'ajax',
        endpoint: '/broadcasting/auth',
        customHandler,
      },
    }),
  });

  return {
    echo,
  };
}
